import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupOne from "../../components/header-signup-one/component";
import {BeatLoader} from 'react-spinners';
import {cartRegister} from "../../services/cartRegister";
import {dataRegister} from "../../services/dataRegister";
import {imagesRegister} from "../../services/imagesRegister";
import {userRegister} from "../../services/userRegister";
import cx from "classnames";
import {langRegister} from "../../services/langRegister";
import {quotesRegister} from "../../services/quotesRegister";
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import IndustrySearch from "../../components/industry-search/component";
import Faq from "../../components/faq/component";
import ErrorHandler from "../../components/error-handler/component";
import {tokenRegister} from "../../services/tokenRegister";
import {industriesRegister} from "../../services/industriesRegister";
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import {scraperRegister} from "../../services/scraperRegister";
import ModalImageSize from "../../components/modal-imagesize/component";
import ModalCoupon from "../../components/modal-coupon/component";
import ModalCropp from "../../components/modal-cropp/component";
import {videoRegister} from "../../services/videoRegister";
import {carouselRegister} from "../../services/carouselRegister";
import queryString from "query-string";
import ModalImageError from "../../components/modal-imageerror/component";

class SignupSlideshow extends Component {

    constructor(props) {
        super(props);
        this.state = {
            industry: null,
            image: null,
            images: [],
            uploaded_images: [],
            scraped_images: [],
            isLoadingButton: false,
            isLoading: true,
            page: 0,
            uploaded_image: null,
            uploaded_image_url: null,
            admin: false,
            error: false,
            industries: [],
            hideButton: false,
            src: null
        };
        this.functions.removeSizeModal = this.functions.removeSizeModal.bind(this);
    };

    componentWillMount() {
        window.scrollTo(0, 0);

        this.update.user();
        this.update.image();

        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/signup/slideshow');
            ReactGA4.send({ hitType: "pageview", page: "/signup/slideshow" });
        }

        //FACEBOOK PIXEL
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactPixel.pageView();
        }
    }

    update = {
        user: () => {
            try {
                let user = userRegister.get();
                if (user) {
                    this.setState({admin: user.reseller || user.inhouse, inhouse: user.inhouse});
                }
            } catch (error) {
                this.setState({
                    error: true
                });
            }
        },
        image: () => {
            try {
                let stored_image = cartRegister.get();
                if (stored_image.admin_slideshow_images) {
                    this.setState({
                        uploaded_images: stored_image.admin_slideshow_images,
                        isLoading: false
                    });
                }else{
                    this.setState({
                        uploaded_images: [],
                        isLoading: false
                    });
                }
            } catch (error) {
                this.setState({
                    error: true,
                    isLoading: false
                });
            }
        }
    };

    functions = {
        scroll: (element) => {
            let offSet = 0, timeout = null;
            element = document.getElementById(element);
            if (element) {
                const elemPos = element ? element.getBoundingClientRect().top + window.pageYOffset : 0;
                window.scroll({top: elemPos + offSet, left: 0, behavior: 'smooth'});
            }
        },
        selectUploadedImage: (item) => {
            try {
                if (item.isValid) {
                    item.selected = !item.selected;
                    if(item.selected){
                        let index = 0;
                        for(let i = 0; i < this.state.uploaded_images.length; i++){
                            if(this.state.uploaded_images[i].number > index){
                                index = this.state.uploaded_images[i].number;
                            }
                        }
                        item.number = index + 1;
                    }else{
                        item.number = null;
                        let list = this.state.uploaded_images.filter((inner_item) => {return inner_item.selected && inner_item.date !== item.date}).sort((a, b) => (a.number > b.number) ? 1 : -1);
                        for(let i = 0; i < list.length; i++){
                            list[i].number = i + 1;
                        }
                        console.log(list);
                        for(let i = 0; i < list.length; i++){
                            for(let m = 0; m < list.length; m++){
                                if(this.state.uploaded_images[m].date === list[i].date){
                                    this.state.uploaded_images[m].number = list[i].number;
                                }
                            }
                        }
                    }
                    this.setState({uploaded_images: this.state.uploaded_images}, () => {
                        cartRegister.setAdminSlideshow(this.state.uploaded_images);
                    });
                }
            } catch (e) {
                console.log(e);
            }
        },
        uploadImage: (e) => {
            try {
                if (e.target.files && e.target.files.length > 0) {
                    if (e.target.files[0].size > 5999000) {
                        this.setState({size_modal: true});
                    } else {
                        const reader = new FileReader();
                        reader.addEventListener("load", () => {
                            this.setState({src: reader.result});
                        });
                        reader.readAsDataURL(e.target.files[0]);
                    }
                }
            } catch (error) {
                console.log(error);
            }
        },
        addCroppedImage: () => {
            let item = this.refs.cropper.getCroppedCanvas().toDataURL('image/jpeg');
            let image_object = {
                url: null,
                data_url: item,
                date: Math.floor(Math.random() * 999999999999999999999),
                description: "",
                isAnalyzing: true,
                isValid: false
            };
            this.state.uploaded_images.unshift(image_object);
            this.setState({uploaded_images: this.state.uploaded_images, src: null}, () => {
                let files = new FormData();
                files.append('image', this.functions.dataURItoBlob(item));
                dataRegister.analyzeImage(files).then((response) => {
                    for (let i = 0; i < this.state.uploaded_images.length; i++) {
                        if (image_object.date === this.state.uploaded_images[i].date) {
                            this.state.uploaded_images[i].isAnalyzing = false;
                            this.state.uploaded_images[i].isValid = response.valid;
                            this.state.uploaded_images[i].url = response.url;
                            this.state.uploaded_images[i].images = response.images;
                        }
                    }
                    this.setState({uploaded_images: this.state.uploaded_images}, () => {
                        cartRegister.setAdminSlideshow(this.state.uploaded_images);
                    });
                }, (error) => {
                    this.setState({src: null}, () => {
                    });
                });
            });
        },
        dataURItoBlob: (dataURI) => {
            var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0) {
                byteString = atob(dataURI.split(',')[1]);
            } else {
                byteString = unescape(dataURI.split(',')[1]);
            }
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            return new Blob([ia], {type: mimeString});
        },
        removeSizeModal: () => {
            this.setState({size_modal: false})
        }
    };

    renders = {
        text: (item) => {
            return langRegister.get("signup-slideshow", item);
        },
        uploadedImage: (item) => {
            return (
                <div className={cx(Styles.imagesContainerItem)}>
                    <div className={cx(Styles.imagesContainerItemPadding)}>
                        {
                            !item.isAnalyzing && !item.error && item.selected &&
                            <div className={Styles.imagesContainerItemOverlayNumber}>
                                {item.number}
                            </div>
                        }
                        {
                            item.isAnalyzing &&
                            <div className={Styles.imagesContainerItemOverlay}>
                                <div className={Styles.imagesContainerItemOverlayText}>
                                    <BeatLoader size={20} color={'#41CBC7'} loading={true}/>
                                    <div
                                        className={Styles.imagesContainerItemOverlayTextInner}>{this.renders.text("item_37")}</div>
                                </div>
                            </div>
                        }
                        {
                            !item.isAnalyzing && !item.isValid && !item.error &&
                            <div className={Styles.imagesContainerItemOverlay}>
                                <div
                                    className={cx(Styles.imagesContainerItemOverlayText, Styles.imagesContainerItemOverlayTextError)}>
                                    {this.renders.text("item_38")}
                                </div>
                            </div>
                        }
                        {
                            !item.isAnalyzing && item.error &&
                            <div className={Styles.imagesContainerItemOverlay}>
                                <div
                                    className={cx(Styles.imagesContainerItemOverlayText, Styles.imagesContainerItemOverlayTextError)}>
                                    {this.renders.text("item_39")}
                                </div>
                            </div>
                        }
                        <div onClick={() => this.functions.selectUploadedImage(item)}
                             className={cx(Styles.imagesContainerItemInner)}>
                            {
                                item.images && item.images.small &&
                                <div style={{backgroundImage: "url(" + item.images.small + ")"}}
                                     className={cx(Styles.imagesContainerItemInnerUploadImage, Styles.imagesContainerItemInnerOwnUpload)}/>
                            }
                            {
                                item.selected &&
                                <div className={Styles.imagesContainerItemActive}/>
                            }
                        </div>
                    </div>
                </div>
            )
        },
        uploadButton: () => {
            return (
                <div className={
                    cx(Styles.imagesContainerItem,
                        {
                            [Styles.imagesContainerItemCenter]: this.state.uploaded_images.length < 1 && this.state.admin,
                        })
                }>
                    <div className={Styles.imagesContainerItemPadding}>
                        <div className={Styles.imagesContainerItemInner}>
                            <div className={Styles.imagesContainerItemInnerIconContainer}>
                                <div className={Styles.imagesContainerItemInnerIcon}>+</div>
                            </div>
                        </div>
                        <input ref="uploadImageFile" onClick={() => this.refs.uploadImageFile.value = null}
                               onChange={(e) => this.functions.uploadImage(e)} type="file"
                               accept="image/jpeg, image/png"
                               className={Styles.imagesContainerItemInnerUpload}/>
                    </div>
                </div>
            )
        }
    };

    render() {
        return (
            <div>
                <HeaderSignupOne history={this.props.history} view={"signup"} props={this.props}/>
                {
                    this.state.size_modal &&
                    <ModalImageSize setLeave={this.functions.removeSizeModal}/>
                }
                {
                    this.state.error_modal &&
                    <ModalImageError setLeave={this.functions.removeSizeModal}/>
                }
                {
                    this.state.cropp_modal &&
                    <ModalCropp setLeave={this.functions.setImageSrc}/>
                }
                {
                    this.state.src &&
                    <div className={Styles.overlayCopper}>
                        <div className={Styles.overlayModalCrop}>
                            {
                                <Cropper
                                    ref='cropper'
                                    modal={false}
                                    src={this.state.src}
                                    style={{height: 400, width: '100%'}}
                                    aspectRatio={1 / 1}
                                    guides={false}
                                    background={false}
                                    zoomOnWheel={false}
                                    viewMode={1}
                                    dragMode={'none'}
                                />
                            }
                            <div className={Styles.overlayModalCropButtons}>
                                <div className={Styles.overlayModalCropButtonsInner}>
                                    <div onClick={() => {
                                        this.setState({src: null})
                                    }} className={Styles.overlayModalCropButtonsItemRemove}>
                                        <img className={Styles.overlayModalCropButtonsItemRemoveIcon}
                                             src={require("../../assets/images/AB_cross_bold.png")}/>
                                    </div>
                                    <div onClick={() => this.functions.addCroppedImage()}
                                         className={Styles.overlayModalCropButtonsItemSelect}>
                                        <img className={Styles.overlayModalCropButtonsItemSelectIcon}
                                             src={require("../../assets/images/AB_checkmark_bold.png")}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {
                    !this.state.isLoading && !this.state.error &&
                    <div className={Styles.containerOuter}>
                        <div className={Styles.container}>
                            {
                                !this.state.error && this.state.uploaded_images.length < 1 &&
                                <div className={Styles.subtitleContainer}>
                                    <div className={Styles.title}>
                                        {this.renders.text('item_1')}
                                    </div>
                                </div>
                            }
                            {
                                !this.state.error && this.state.uploaded_images.length > 0 &&
                                <div className={Styles.subtitleContainer}>
                                    <div className={Styles.title}>
                                        {this.renders.text('item_2')}
                                    </div>
                                </div>
                            }
                            {
                                !this.state.modal &&
                                <div className={
                                    cx(Styles.imagesContainer,
                                        {
                                            [Styles.imagesContainerCenter]: this.state.uploaded_images.length < 1 && this.state.admin,
                                        })
                                }>
                                    {
                                        this.state.admin &&
                                        this.renders.uploadButton()
                                    }
                                    {
                                        this.state.uploaded_images.map((item) => {
                                            return (
                                                this.renders.uploadedImage(item)
                                            )
                                        })
                                    }
                                </div>
                            }
                            <div onClick={() => {
                                if(this.state.uploaded_images.filter((item) => {return item.selected}).length < 1 || (this.state.uploaded_images.filter((item) => {return item.selected}).length > 1 && this.state.uploaded_images.filter((item) => {return item.selected}).length < 11)){
                                    setTimeout(() => {
                                        let view = quotesRegister.getView();
                                        if (view === "custom") {
                                            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + "/signup/quotes-custom");
                                        } else {
                                            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + "/signup/quotes");
                                        }
                                    }, 200);
                                }
                            }} className={
                                cx(Styles.button,
                                    {
                                        [Styles.buttonActive]: this.state.uploaded_images.filter((item) => {return item.selected}).length < 1 || (this.state.uploaded_images.filter((item) => {return item.selected}).length > 1 && this.state.uploaded_images.filter((item) => {return item.selected}).length < 11),
                                    })
                            }>
                                {this.renders.text("item_30")}
                            </div>
                            <div onClick={() => {
                                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + "/signup/video");
                            }} className={Styles.backButton}>
                                {this.renders.text("item_29")}
                            </div>
                        </div>
                    </div>
                }
                {
                    this.state.isLoading &&
                    <div className={Styles.loader}>
                        <BeatLoader size={30} color={'#41CBC7'} loading={true}/>
                    </div>
                }
                {
                    !this.state.isLoading && this.state.error &&
                    <div className={Styles.loader}>
                        <ErrorHandler props={this.props}/>
                    </div>
                }
                <div id={"bottom"} style={{width: "100%"}}/>
            </div>
        );
    }
}

export default SignupSlideshow;


// WEBPACK FOOTER //
// ./src/pages/signup-slideshow/component.js